module.exports = __webpack_public_path__ + "img/banner-16.5bb69a73.jpg";